<template>
    <div class="book-insight-example">
        <book-insight :book-insight="bookInsight" />
        <div class="bi-audio-and-themes">
            <landing-container-player
                :book-insight="bookInsight"
                :playing-book-insight="bookInsight.id == playingBookInsight"
                @on-play="(value) => playingBookInsight = value"
            />
            <div class="themes">
                <div class="themes-container" :class="`themes-container-${ bookInsight.id }`">
                    <div class="theme">
                        <h6><i><strong>1. {{ bookInsight.themes[0].title }}</strong></i></h6>
                        <div class="ql-editor" v-html="bookInsight.themes[0].body" />
                        <p class="subscribe">
                            Subscribe now and access the rest of this book insight.
                        </p>
                    </div>
                </div>
                <button
                    v-longclick="() => scrollTheme(bookInsight.id)"
                    type="button"
                    class="expand-theme-arrow"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { longClickDirective } from "vue-long-click";
const longClickInstance = longClickDirective({ delay: 0, interval: 200 })

export default {
    name: "BookInsightExample",
    directives: {
        "longclick": longClickInstance
    },
    components: {
        bookInsight:() => import(/* webpackChunkName: "book-insight"*/ "@c/books-insights/carousel/book-insight"),
        landingContainerPlayer:() => import(/* webpackChunkName: "landing-player"*/ "@c/landing-player/player-container")
    },
    props: {
        bookInsight: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            playingBookInsight: "0",
            currentThemeScrollPosition: 0,
            themeScrollSpeed: 40
        };
    },
    methods: {
        scrollTheme(bookInsightId) {
            const themesContainer = document.querySelector(`.themes-container-${bookInsightId}`);
            const scrollPixelsToMove = this.currentThemeScrollPosition + this.themeScrollSpeed;
            themesContainer.scrollTo(0, scrollPixelsToMove, { behavior: "smooth" });
            this.currentThemeScrollPosition = scrollPixelsToMove;
        }
    }
}
</script>

<style lang="scss">
.book-insight-example {
    display: flex;
    border-radius: 20px;
    background: linear-gradient(90deg, transparent 80px, $dark-gray 80px);
    padding: 20px 0;

    @media (max-width: $md) {
        flex-direction: column;
        background: linear-gradient(-180deg, transparent 150px, $dark-gray 150px);
    }

    .book-insight {
        width: 222px;
        flex-shrink: 0;
        pointer-events: none;
        box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.1);
        border-radius: 15px !important;

        @media (max-width: $md) {
            margin: 0 auto;
        }

        .bi-actions {
            display: none !important;
        }
    }

    .bi-audio-and-themes {
        padding: 0 50px;

        @media (max-width: $md) {
            padding: 0 20px;
        }


        .themes {
            height: 260px;
            position: relative;
            font-size: 16px;
            line-height: 29px;
            margin-top: 30px;

            * {
                background-color: transparent !important;
            }

            .theme-overlay {
                background: linear-gradient(0deg, rgba(241, 247, 246, 0.8) 0, rgba(255, 255, 255, 0) 100px);
                position: absolute;
                right: 0;
                top: 0;
                left: 0;
                height: calc(100% - 40px);
            }

            .themes-container {
                height: calc(100% - 40px);
                overflow: hidden;
                scroll-behavior: smooth;

                &::before {
                    content: "";
                    position: absolute;
                    top: 0;
                    width: 100%;
                    height: 40px;
                    background: linear-gradient(0deg, rgba(255, 255, 255, 0) 0, $dark-gray 40px);
                }

                &::after {
                    content: "";
                    position: absolute;
                    bottom: 40px;
                    width: 100%;
                    height: 100px;
                    background: linear-gradient(0deg, $dark-gray 0, rgba(255, 255, 255, 0) 100px);
                }

                .theme {
                    margin-bottom: 50px;
                    margin-top: 30px;
                    color: white;

                    h6 {
                        margin-bottom: 20px;
                        margin-top: 20px;
                    }

                    p {
                        * {
                            color: white !important;
                        }
                    }

                    &:first-child {
                        h6 {
                            margin-top: 0;
                        }
                    }

                    .subscribe {
                        margin-top: 20px;
                        font-size: 16px;
                        font-weight: 600;
                    }
                }
            }

            .expand-theme-arrow {
                position: absolute;
                bottom: 0;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                height: 40px;
                border: 0;

                &:before {
                    content: "";
                    position: absolute;
                    background-image: url("~@assets/img/book-insights/icons/nav-down.svg");
                    background-repeat: no-repeat;
                    width: 24px;
                    height: 24px;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                }

                &:focus {
                    outline: 0;
                }
            }
        }
    }
}
</style>
